import { ItemType, Level, SelectionRejection } from "./interfaces"

/** Ordre d'affichage des familles d'éléments */
export const ITEM_TYPES: ItemType[] = ["personnage", "objet", "lieu"]

/** Intitulés des zones du plateau */
export const ITEM_TYPE_LABELS: Record<ItemType, string> = {
  personnage: "Personnages",
  objet: "Objets",
  lieu: "Lieux",
}

export const LEVELS: Level[] = [1, 2, 3]

/** Durée de l'animation de disparition d'un indice (doit correspondre au SCSS) */
export const CLUE_EXIT_DURATION_MS = 450

/** Message annoncé aux lecteurs d'écran quand la bonne tuile est trouvée (mode contrôle) */
export const CORRECT_SELECTION_MESSAGE = "Bonne réponse !"

/**
 * Messages annoncés aux lecteurs d'écran quand une sélection est refusée :
 * le tremblement et le son ne suffisent pas à transmettre l'information.
 */
export const REJECTION_MESSAGES: Record<SelectionRejection, string> = {
  maxReached: "Tu as déjà écarté autant de tuiles que d'indices lus.",
  alreadyFound: "Tu as déjà trouvé la tuile de cet indice.",
  wrongTile: "Ce n'est pas la tuile qui correspond à cet indice.",
}

/** Refus signalés par le seul tremblement, sans son d'erreur */
export const SILENT_REJECTIONS: SelectionRejection[] = ["maxReached"]
